import { useEffect, useRef } from "react";
import checkIcon from "./assets/check-icon.svg";
import "./progress-circle.scss";

type ProgressCircleProps = {
  progress: number;
  icon?: string;
  size?: number;
};

const ProgressCircle = (props: ProgressCircleProps) => {
  const { progress = 0, icon, size = 14 } = props;
  const bar = useRef<HTMLDivElement>();

  useEffect(() => {
    bar.current.style.setProperty(
      "--progress",
      `${Math.ceil((progress / 100) * 360)}deg`
    );
  }, [progress]);

  return (
    <div className="cfmui-progress-circle">
      <div
        className={"progress-circle" + (progress > 50 ? " over50" : "")}
        style={{ fontSize: size }}
      >
        {icon ? (
          <span className="icon">
            <img
              className={progress >= 100 && "completed"}
              src={icon}
              alt="Icon"
            />
          </span>
        ) : (
          <span className="text">{progress}%</span>
        )}
        {progress >= 100 && (
          <span className="check-icon">
            <img src={checkIcon} alt="Check icon" />
          </span>
        )}
        <div className="left-half-clipper">
          <div className="first50-bar"></div>
          <div ref={bar} className="value-bar"></div>
        </div>
      </div>
    </div>
  );
};

export default ProgressCircle;
